export const search = {
  // Search page
  "search.title": "Rechercher des fournisseurs par produit",
  "search.results": "résultats trouvés",
  "search.results_title": "Résultats de recherche",
  "search.no_results": "Aucun fournisseur trouvé",
  "search.no_results_desc": "Essayez de chercher un produit (ex: iPhone, riz, voiture) ou une catégorie",
  "search.filters": "Filtres",
  "search.sort": "Trier par",
  "search.sort.relevance": "Pertinence",
  "search.sort.distance": "Distance",
  "search.sort.rating": "Note",
  "search.sort.name": "Nom",
  "search.sort.alpha_asc": "Nom (A-Z)",
  "search.sort.alpha_desc": "Nom (Z-A)",
  "search.placeholder": "Cherchez un produit (iPhone, riz...) ou catégorie",
  "search.suggestions": "Essayez :",
  "search.loading": "Chargement des fournisseurs...",
  "search.showing": "Affichage de",
  "search.of": "sur",
  "search.suppliers": "fournisseurs",
  "search.total_suppliers": "{{count}} fournisseurs au total",
  "search.total_suppliers_count": "{{count}} fournisseurs totaux",
  "search.intelligent_hint": "Recherchez n'importe quel produit pour trouver tous les fournisseurs de cette catégorie",
  
  // Category match indicator
  "search.category_match": "Fournisseurs dans la catégorie : {{category}}",
  "search.product_match": "Trouvé via le produit : {{product}}",
  
  // Filters
  "filter.category": "Catégorie",
  "filter.location": "Localisation",
  "filter.distance": "Distance",
  "filter.rating": "Note minimum",
  "filter.price_range": "Fourchette de prix",
  "filter.min": "Min",
  "filter.max": "Max",
  "filter.verified": "Entreprises vérifiées uniquement",
  "filter.apply": "Appliquer les filtres",
  "filter.clear": "Effacer les filtres",
  "filter.reset": "Réinitialiser les filtres",
  "filter.city": "Ville principale",
  "filter.all_cities": "Toutes villes",
  "filter.all_categories": "Toutes catégories",
  "filter.max_distance": "Distance maximale",
  "filter.min_rating": "Note minimale",
  "filter.all_ratings": "Toutes notes",
  "filter.verified_only": "Entreprises vérifiées uniquement",
  "filter.by_city": "Filtrez par ville",
  "filter.by_category": "Filtrez par catégorie",
  "filter.by_distance": "Filtrez par distance",
  "filter.by_rating": "Filtrez par note",
  "filter.stars": "étoiles",
  
  // Distance options
  "distance.5km": "Dans un rayon de 5 km",
  "distance.10km": "Dans un rayon de 10 km",
  "distance.25km": "Dans un rayon de 25 km",
  "distance.50km": "Dans un rayon de 50 km",
  "distance.100km": "Dans un rayon de 100 km",
  
  // View options
  "view.list": "Vue liste",
  "view.map": "Vue carte",
  "view.grid": "Vue grille",
  
  // Results
  "results.verified": "Vérifié",
  "results.reviews": "avis",
  "results.view_profile": "Voir le profil",
  "results.contact": "Contacter",
  "results.no_match": "Aucun fournisseur ne correspond aux filtres sélectionnés.",
  
  // Search suggestions
  "search.including": "Incluant",
  "search.suggested_category": "Catégorie suggérée",

  // Search translation (Alibaba-style)
  "search.translating": "Traduction...",
  "search.translated_from": "Traduit depuis",
  
  // Search suggestion dropdown
  "search.suggestion.recent": "Récent",
  "search.suggestion.supplier": "Fournisseur",
  "search.suggestion.category": "Catégorie",
  "search.type.suppliers": "Fournisseurs",
  "search.type.products": "Produits",
  "search.type.categories": "Catégories",
  "search.type.locations": "Lieux",
  "search.results_count": "résultat{{count, plural, one {} other {s}}}",
  "search.try_other_terms": "Essayez avec d'autres termes",
  "search.recent_searches": "Recherches récentes",
  "search.clear": "Effacer",
  "search.keyboard_navigate": "naviguer",
  "search.keyboard_select": "sélectionner",
  "search.keyboard_close": "fermer",
  
  // Location and UI
  "search.locating": "Localisation en cours...",
  "search.use_my_location": "Utiliser ma position",
  "search.my_location": "Ma position",
  "search.your_position": "Votre position",
  "search.reset": "Réinitialiser",
  "search.hide_filters": "Masquer les filtres",
  "search.show_filters": "Afficher les filtres",
  "search.verified": "Vérifié",
  "search.full_address_available": "Adresse complète disponible",
  "search.call": "Appeler",
  "search.send_email": "Envoyer un email",
  "search.make_appointment": "Prendre rendez-vous",
  "search.view_details": "Voir détails",
  "search.distance_from": "Distance depuis votre position actuelle",
  "search.distance_from_location": "Distance depuis {{location}}",
  "search.select_city_or_use_position": "Sélectionnez une ville ou utilisez votre position",
  "search.location_not_supported": "La géolocalisation n'est pas prise en charge par votre navigateur",
  "search.location_permission_denied": "Vous avez refusé l'accès à votre position",
  "search.location_unavailable": "Position indisponible",
  "search.location_timeout": "Demande de position expirée",
  "search.location_error": "Erreur lors de la récupération de la position",
  "search.timeout_error": "La recherche a pris trop de temps. Veuillez réessayer.",
  "search.map_timeout_error": "La recherche sur la carte a pris trop de temps.",

  // Home page search placeholders
  "search.product_placeholder": "Rechercher un produit...",
  "search.supplier_placeholder": "Nom du fournisseur",
  "search.location_placeholder": "Localisation",
  "search.category_placeholder": "Catégorie",
  "search.find_products": "Rechercher",
  "search.find_suppliers": "Rechercher"
};

export default search;